import React from "react"
import MyCard from "@common-utils/MyCard"
import MyTooltip from "@common-utils/MyTooltip"
import { Form, Formik } from "formik"
import MyInputField from "@common-utils/fields/MyInputField"
import { IRequestModel } from "./core/_models"
import { useFournisseurListingContext } from "./FournisseurListing"
import MySelectField from "@common-utils/fields/MySelectField"
import { CONST_FOURNISSEUR_FORMES_JURIDIQUE_OPTIONS_FOR_SELECT2, CONST_FOURNISSEUR_TYPES_OPTIONS_FOR_SELECT2 } from "@common-constants/*"

// Filters
const Filters = () => {
     const context = useFournisseurListingContext()

     const initialValues: IRequestModel = {
          ...context.filters,
     }

     function handleSubmit(values: IRequestModel) {
          context.setFilters(prev => ({
               ...prev,
               ...values,
          }))
          context.setAreFiltersVisible(false)
          context.setItemInPreview(null)
     }

     function handleReset() {
          context.filtersFormikRef.current.resetForm() // Reset local form
          context.simpleSearchBarFormikRef.current.resetForm() // Reset search bar form
          context.setItemInPreview(null)
          context.setAreFiltersVisible(false)

          // Reset payload filters
          context.setFilters({
               page: 1,
               pageLength: 20,
          })

          context.filtersFormikRef.current.setSubmitting(true)
     }

     function handleClickHideFilters() {
          // Hide filters
          context.setAreFiltersVisible(prev => !prev)
          // Show preview only if it was opened before showing filters
          context.setItemInPreview(prev => {
               if (prev) {
                    return { ...prev, isPreviewVisible: true }
               }
               return null
          })
     }

     return (
          <MyCard>
               <MyCard.Header
                    isCollapseIconShown={false}
                    rightSideContent={
                         <MyTooltip title={"Cacher les filters"}>
                              <button className={"btn btn-sm btn-outline btn-outline-secondary "} onClick={handleClickHideFilters}>
                                   <i className={"fas fa-eye-slash fs-4 text-dark"} />
                              </button>
                         </MyTooltip>
                    }
               >
                    Filtres
               </MyCard.Header>

               <MyCard.Body>
                    <Formik initialValues={initialValues} onSubmit={handleSubmit} innerRef={context.filtersFormikRef}>
                         {helpers => {
                              return (
                                   <Form noValidate autoComplete="off">
                                        <div className="row mb-5">
                                             <label className="col-lg-4 col-form-label fw-bold fs-6">Mot clé</label>

                                             <div className="col-lg-8">
                                                  <MyInputField
                                                       name={"keyword"}
                                                       value={helpers.values.keyword}
                                                       onChange={val => {
                                                            helpers.setFieldValue("keyword", val).then()
                                                            context.simpleSearchBarFormikRef.current.setFieldValue("keyword", val).then()
                                                       }}
                                                       isInvalid={!!helpers.errors.keyword}
                                                       placeholder={"Rechercher ..."}
                                                  />
                                                  {helpers.errors.keyword && <div className={"text-danger"}>{helpers.errors.keyword}</div>}
                                             </div>
                                        </div>

                                        <div className="row mb-5">
                                             <label className="col-lg-4 col-form-label fw-bold fs-6">Type</label>

                                             <div className="col-lg-8">
                                                  <MySelectField
                                                       options={CONST_FOURNISSEUR_TYPES_OPTIONS_FOR_SELECT2}
                                                       name={`types`}
                                                       isSearchable={false}
                                                       value={helpers.values.types}
                                                       isMulti
                                                       onChange={value => helpers.setFieldValue(`types`, value)}
                                                       isInvalid={!!helpers.errors.types}
                                                  />
                                                  {helpers.errors.types && <div className={"text-danger"}>{helpers.errors.types}</div>}
                                             </div>
                                        </div>

                                        <div className="row">
                                             <label className="col-lg-4 col-form-label fw-bold fs-6">Forme juridique</label>

                                             <div className="col-lg-8">
                                                  <MySelectField
                                                       options={CONST_FOURNISSEUR_FORMES_JURIDIQUE_OPTIONS_FOR_SELECT2}
                                                       name={`formesJuridique`}
                                                       isSearchable={false}
                                                       isMulti
                                                       value={helpers.values.formesJuridique}
                                                       onChange={value => helpers.setFieldValue(`formesJuridique`, value)}
                                                       isInvalid={!!helpers.errors.formesJuridique}
                                                  />
                                                  {helpers.errors.formesJuridique && <div className={"text-danger"}>{helpers.errors.formesJuridique}</div>}
                                             </div>
                                        </div>

                                        <div className="separator separator-dotted mt-5 mb-8"></div>

                                        <div className={"text-end"}>
                                             <button
                                                  className={"btn btn-sm btn-outline btn-outline-primary d-inline-flex align-items-center me-2"}
                                                  type={"button"}
                                                  disabled={helpers.isSubmitting}
                                                  onClick={() => handleReset()}
                                             >
                                                  <span className={"d-none d-lg-block"}>Réinitialiser</span> <i className={"fas fa-sync ms-lg-1"} />
                                             </button>
                                             <button className={"btn btn-sm btn-primary d-inline-flex align-items-center"} type={"submit"} disabled={helpers.isSubmitting}>
                                                  <span className={"d-none d-lg-block"}>Filtrer </span>
                                                  {!helpers.isSubmitting ? (
                                                       <i className={"fas fa-filter ms-md-1"} />
                                                  ) : (
                                                       <span className="spinner-border spinner-border-sm align-middle ms-lg-1" />
                                                  )}
                                             </button>
                                        </div>
                                   </Form>
                              )
                         }}
                    </Formik>
               </MyCard.Body>
          </MyCard>
     )
}

export default Filters
